import React, { Component } from 'react';
import { Map, TileLayer, Marker, Popup } from 'leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import './styles.scss';

// Fix for default marker icon issue in Leaflet with webpack
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

// Custom marker icon
const customIcon = new L.Icon({
    iconUrl: require('../../assets/img/marker-google-map.png').default,
    iconSize: [32, 45],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32]
});

let zoom;

if(window.matchMedia("(min-width: 400px)").matches) {
	zoom = 15;
} else {
	zoom = 14;
}

const mapStyles = {
	width: '100%',
	position: 'relative',
	minHeight: '22rem',
};

export class MapContainer extends Component {
	componentDidMount() {
		// Create map instance
		this.map = L.map('map', {
			center: [-38.7380252474939, -62.25983219857705],
			zoom: zoom,
			layers: [
				L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
					attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				})
			]
		});

		// Add marker
		L.marker([-38.73772864749396, -62.25983219857705], { icon: customIcon })
			.addTo(this.map)
			.bindPopup('Río Negro 737, Bahía Blanca, Buenos Aires, Argentina');

		// Uncomment to add alternative location
		// L.marker([-38.731720, -62.282179], { icon: customIcon })
		//	.addTo(this.map)
		//	.bindPopup('Ubicación alternativa');
	}

	componentWillUnmount() {
		if (this.map) {
			this.map.remove();
		}
	}

	render() {
		return (
			<section className="mapa">
				<div id="map" style={mapStyles}></div>
			</section>
		);
	}
}

export default MapContainer;